define([
    "angular",
    "../hereMapsModule"
], function(angular, hereMapsModule) {
    "use strict";
     hereMapsModule.provider("hereMapsConfigurationServiceUrl", function () {

        var url;

        this.$get = [function () {
            return {
                getUrl: geUrl
            };
        }];

        function geUrl() {
            return url;
        }

        this.configure = function (server) {
            url = server.url;
        };

    });
});